import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import analytics from './modules/analytics'
import users from './modules/users'
import tagging from './modules/tagging'
import statistics from './modules/statistics'
import types from './modules/types'
import sidebar from './modules/sidebar'
import cases from './modules/cases'
import monitoring from './modules/monitoring'
import scoringProfiles from "@/store/modules/scoring-profiles";
import alerts from './modules/alerts'
import entity from './modules/entity'
import counterparty from './modules/counterparty'
import rates from './modules/rates'
import directions from './modules/directions'
import pdf from './modules/pdf'
import userGuide from './modules/user-guide'
import report from './modules/report'
import comments from './modules/comments'
import integrations from './modules/integrations'
import autotrace from './modules/autotrace'
import defiExposure from './modules/defi-exposure'
import permissions from './modules/permissions'
import blockchain from './modules/blockchain'
import ai from './modules/ai'
import arn from './modules/arn'
import kytLab from './modules/kyt-lab'
import files from './modules/files'
import multiBlockchain from './modules/multi-blockchain'
import dashboard from './modules/dashboard'
import history from './modules/history'
import screening from './modules/screening'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    permissions,
    alerts,
    user,
    users,
    cases,
    types,
    sidebar,
    tagging,
    analytics,
    monitoring,
    statistics,
    scoringProfiles,
    entity,
    counterparty,
    rates,
    directions,
    pdf,
    userGuide,
    report,
    comments,
    integrations,
    autotrace,
    defiExposure,
    blockchain,
    ai,
    arn,
    kytLab,
    files,
    multiBlockchain,
    dashboard,
    history,
    screening,
  },
})
